import {
  Row,
  ListGroupItem as ListGroupItemStrap,
  Col,
  Container
} from 'reactstrap'
import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { FaApple, FaGooglePlay } from 'react-icons/fa'
import { media } from 'ui/rwd'

const Category = styled.span``

const Answer = styled.span`
  color: ${theme('black')};
  font-size: 1.25rem;
  cursor: default;
`

const Question = styled.span`
  text-transform: uppercase;
`

const PinkLink = styled.span`
  color: ${theme('pink')};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
const AppleIcon = styled(FaApple).attrs(props => ({
  color: props.theme.pink
}))``
const PlayIcon = styled(FaGooglePlay).attrs(props => ({
  color: props.theme.pink
}))``

const ListGroupItem = styled(ListGroupItemStrap)`
  display: flex;
  align-items: center;
`

const FaqCol = styled(Col)`
  padding: 0 !important;
`

const Spacer = styled(Col)`
  display: none;
  ${media.md`
    display: block;
  `}
`

const Categories = styled(Container)`
  margin-top: 3rem;
  margin-bottom: 4rem;
`

const CategoryName = styled.h2`
  color: ${theme('secondary')};
  padding-bottom: 2rem;
`

const CategoriesRow = styled(Row)`
  justify-content: center;
  padding: 0 2rem;
`

const PageDescription = styled.p`
  font-size: 1.2rem;
  padding: 0;
`

const QuestionsSection = styled.div`
  background: ${theme('seashell')};
  padding: 1rem 4rem;
  margin: 0 -15px;
`

const QuestionsRow = styled(Row)`
  padding: 4rem 0;
`

export {
  Answer,
  FaqCol,
  Question,
  Category,
  CategoryName,
  Categories,
  CategoriesRow,
  PinkLink,
  PageDescription,
  AppleIcon,
  PlayIcon,
  ListGroupItem,
  Spacer,
  QuestionsSection,
  QuestionsRow
}
